import ProductsFull from './ProductsFull';

export default ProductsFull;
